// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"547":"919fd6ff","660":"8b50f611","806":"d74ac9d2"}[chunkId] + ".css";
};